import { combineReducers } from '@reduxjs/toolkit';

import usersList from './usersList';
import createUser from './createUser';
import updateUser from './updateUser';

const usersReducer = combineReducers({
  usersList,
  createUser,
  updateUser,
});

export default usersReducer;
